import { appActions } from '../AppActions'
import AccountTitleRepository from '../../infra/AccountTitleRepository'
import history from '../../util/history'
import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleDetailEvent from '../../event/AccountTitleDetailEvent'

const onRequestDeleteDetail = async detail => {
  const response = await AccountTitleRepository.requestDeleteByDetailId(detail.id).catch(e => e)
  if (response instanceof Error) {
    appActions.showAlert(response, '削除できませんでした')
    return false
  }

  AppDispatcher.dispatchWithType(AccountTitleDetailEvent.onClear)
  appActions.snackbar('削除しました', 'success', true)
  history.goBack()
  return true
}

export default onRequestDeleteDetail
